import React, { ForwardedRef, forwardRef } from "react";
import classNames from "classnames";
import { InputProps, Sizes } from "./types";

const getConditionalProps = (invalid: boolean, disabled: boolean) => ({
  "aria-invalid": invalid || undefined,
  disabled: disabled || undefined,
});

const getIconProps = (inputSize: Sizes) => {
  const iconSize = inputSize === "md" || inputSize === "lg" ? 16 : 14;
  return {
    fill: "currentColor",
    className: "rds-Input-icon",
    height: iconSize,
    width: iconSize,
    ["aria-hidden"]: true,
    focusable: false,
  };
};

const Input = forwardRef(
  (
    {
      className,
      disabled = false,
      icon: InputIcon,
      iconPosition = "left",
      invalid = false,
      length,
      size = "md",
      ...rest
    }: InputProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const inputClasses = classNames(
      "rds-Input",
      {
        "is-disabled": disabled,
        "is-invalid": invalid,
        [`rds-Input--${size}`]: size !== "md",
        [`rds-Input--length${length?.toUpperCase()}`]: length,
      },
      className
    );

    return (
      <div className={inputClasses}>
        {InputIcon && iconPosition === "left" && (
          <InputIcon {...getIconProps(size)} />
        )}
        <input
          ref={ref}
          {...rest}
          {...getConditionalProps(invalid, disabled)}
        />
        {InputIcon && iconPosition === "right" && (
          <InputIcon {...getIconProps(size)} />
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
